import { QueryClient } from '@tanstack/react-query';

export function createQueryClient() {
	return new QueryClient({
		defaultOptions: {
			queries: {
				retry: 1,
				staleTime: 30_000,
				refetchOnWindowFocus: false,
			},
			mutations: {
				retry: 0,
			},
		},
	});
}

const queryClient = createQueryClient();

export default queryClient;
